{
  "pages": {
    "listTitle": "Dự án",
    "addTitle": "Thêm dự án",
    "editTitle": "Sửa dự án",
    "detailsTitle": "Chi tiết dự án",
    "permissionDenied": "Bạn không có quyền xem dự án.",
    "createPermissionDenied": "Bạn không có quyền tạo dự án.",
    "editPermissionDenied": "Bạn không có quyền sửa dự án."
  },
  "inboxLabel": "Việc lẻ",
  "status": {
    "active": "Đang chạy",
    "completed": "Hoàn thành",
    "archived": "Đã lưu trữ"
  },
  "views": {
    "label": "Chế độ xem dự án",
    "list": "Danh sách",
    "kanban": "Kanban"
  },
  "kanban": {
    "emptyColumn": "Không có dự án",
    "truncated": "Đang hiển thị {{shown}}/{{total}} dự án"
  },
  "fields": {
    "name": "Tên dự án",
    "description": "Mô tả",
    "status": "Trạng thái",
    "owner": "Chủ dự án",
    "ownerInput": "Chủ dự án",
    "clinic": "Chi nhánh",
    "clinicOptional": "Chi nhánh (tuỳ chọn)",
    "startDate": "Ngày bắt đầu",
    "endDate": "Ngày kết thúc",
    "tasks": "Công việc",
    "openTasks": "Đang mở",
    "doneTasks": "Hoàn thành",
    "totalTasks": "Tổng việc"
  },
  "table": {
    "name": "Tên",
    "owner": "Chủ dự án",
    "status": "Trạng thái",
    "dates": "Thời gian",
    "tasks": "Công việc",
    "description": "Mô tả",
    "clinic": "Chi nhánh",
    "createdBy": "Người tạo",
    "createdAt": "Ngày tạo",
    "updatedAt": "Ngày cập nhật",
    "tasksDone": "Số việc đã xong",
    "actions": "Thao tác"
  },
  "placeholders": {
    "name": "Ví dụ: Niềng răng 2026",
    "description": "Ví dụ: Theo dõi các việc của chiến dịch",
    "owner": "Chọn chủ dự án",
    "clinic": "Chọn chi nhánh",
    "date": "Chọn ngày"
  },
  "actions": {
    "add": "Thêm dự án",
    "edit": "Chỉnh sửa",
    "delete": "Xóa",
    "archive": "Lưu trữ",
    "view": "Xem",
    "viewDetails": "Xem chi tiết",
    "changeStatus": "Chuyển trạng thái",
    "history": "Lịch sử",
    "archiving": "Đang lưu trữ...",
    "save": "Lưu",
    "cancel": "Hủy",
    "refresh": "Làm mới",
    "addTask": "Thêm công việc"
  },
  "filters": {
    "status": "Trạng thái",
    "search": "Tìm dự án",
    "allStatuses": "Tất cả trạng thái",
    "owner": "Chủ dự án",
    "selectStatus": "Chọn trạng thái",
    "allOwners": "Tất cả chủ dự án",
    "selectOwner": "Chọn chủ dự án",
    "clinic": "Chi nhánh",
    "allClinics": "Tất cả chi nhánh",
    "selectClinic": "Chọn chi nhánh",
    "hideInboxOn": "Có",
    "trigger": "Bộ lọc",
    "title": "Lọc dự án",
    "reset": "Xóa lọc",
    "apply": "Áp dụng",
    "all": "Tất cả",
    "none": "Không chọn",
    "hideInbox": "Ẩn Việc lẻ"
  },
  "dialogs": {
    "archiveConfirm": "Lưu trữ dự án này? Các việc chưa đóng sẽ chuyển về Việc lẻ.",
    "deleteConfirm": "Xóa dự án \"{{name}}\"? Các công việc sẽ chuyển về Việc lẻ.",
    "deleteNamedConfirm": "Xóa dự án \"{{name}}\"?"
  },
  "validation": {
    "nameRequired": "Vui lòng nhập tên dự án",
    "ownerRequired": "Vui lòng chọn chủ dự án"
  },
  "toasts": {
    "createSuccess": "Đã tạo dự án",
    "updateSuccess": "Đã cập nhật dự án",
    "statusUpdated": "Đã cập nhật trạng thái dự án",
    "statusUpdateFailed": "Không cập nhật được trạng thái dự án",
    "invalidStatusTransition": "Không thể chuyển trạng thái này",
    "inboxStatusLocked": "Không thể đổi trạng thái Việc lẻ",
    "archived": "Đã lưu trữ dự án",
    "deleted": "Đã xóa dự án",
    "loadFailed": "Không tải được danh sách dự án",
    "loadOneFailed": "Không tải được dự án",
    "saveFailed": "Không lưu được dự án",
    "deleteFailed": "Không xóa được dự án",
    "archiveFailed": "Không lưu trữ được dự án"
  },
  "empty": {
    "noProjects": "Chưa có dự án nào",
    "noTasks": "Chưa có công việc trong dự án này"
  }
}
